/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var LocationPinIcon20Solid = forwardRef('LocationPinIcon20Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M3.753 5.475c-2.401 4.715 1.465 9.08 4.817 12.71.763.826 2.087.819 2.846-.01 3.316-3.62 7.19-7.89 4.875-12.61-1.19-2.428-3.6-3.902-6.29-3.902-2.654 0-5.039 1.436-6.248 3.812Zm6.246 6.611a3.333 3.333 0 1 0 0-6.666 3.333 3.333 0 0 0 0 6.666Z" })));
});
